export const getFullBuyTariffLink = (salePackageId: number | null, alias: string | null, isVillage = false): string => {
    const queryString = new URLSearchParams();

    if (alias) {
        queryString.append('tariffLine', alias);

        if (salePackageId) {
            queryString.append('salePackageId', String(salePackageId));
        }
    }

    if (isVillage) {
        queryString.append('filters', 'cottage');
    }

    queryString.sort();
    const hasQS = Boolean([...queryString.keys()].length);

    return '/full-buy'.concat(hasQS ? `?${queryString.toString()}` : '');
};
